import { IBibleBook } from 'types';
import { useEffect, useMemo, useState, useCallback } from 'react';
import { BooksService } from 'core/services';
import { useAppSelector } from 'store/hooks';
import selectLanguages from 'store/selectors/selectLanguages';
import { TRANSLATIONS_IDS_MAP } from 'config/constants';

const useBooks = () => {
  const [booksList, setBooksList] = useState<IBibleBook[]>([]);
  const langShortcut = useAppSelector(selectLanguages);
  const translationId = useMemo(() => TRANSLATIONS_IDS_MAP[langShortcut], [langShortcut]);

  const getBooksByNumberAndTranslationId = useCallback(async (bookNumber: number, translation_id: number): Promise<IBibleBook[]> => {
    const result = await BooksService.getBooksByNumberAndTranslationId(bookNumber, translation_id);
    return result;
  }, []);

  useEffect(() => {
    BooksService.getBooksListByTranslationId(translationId)
      .then(data => {
        setBooksList(data);
      });
  }, [translationId]);

  return {
    booksList,
    getBooksByNumberAndTranslationId,
  };
};

export default useBooks;
